import React from 'react';
import './Home.css';
import { useUser } from '../contexts/UserContext';

const Home: React.FC = () => {
  const { user } = useUser();
  const firstName = user?.name?.split(' ')[0] || 'there';

  const workflowSteps = [
    {
      number: 1,
      title: 'Request',
      role: `${firstName} (You)`,
      color: '#FFFDE7',
      borderColor: '#000',
      isReview: false,
    },
    {
      number: 2,
      title: 'Initial Screening',
      role: 'Data and Business Reviewer',
      color: '#FFFDE7',
      borderColor: '#000',
      isReview: false,
    },
    {
      number: 3,
      title: 'Data Quality Review',
      role: 'Data Quality Reviewer',
      color: '#FFFDE7',
      borderColor: '#000',
      isReview: true,
    },
    {
      number: 4,
      title: 'Legal Review',
      role: 'Legal Reviewer',
      color: '#e8e8e8',
      borderColor: '#000',
      isReview: true,
    },
    {
      number: 5,
      title: 'Business Review',
      role: 'Business Reviewer',
      color: '#e8e8e8',
      borderColor: '#000',
      isReview: true,
    },
    {
      number: 6,
      title: 'Solution Published',
      role: 'Solution Owner',
      color: '#e8e8e8',
      borderColor: '#000',
      isReview: false,
    },
  ];

  const firstGroupSteps = workflowSteps.slice(0, 2);
  const splitStep = workflowSteps[2];
  const secondGroupSteps = workflowSteps.slice(3);

  const renderBox = (step: typeof workflowSteps[number], background?: string) => (
    <div className={`workflow-box ${step.isReview ? 'review' : ''}`}
      style={{
        background: background || step.color,
        borderColor: step.borderColor,
      }}>
      <div className="step-number">
        {step.number}
      </div>
      <div className="step-title">{step.title}</div>
      <div className="step-role">{step.role}</div>
    </div>
  );

  const renderStep = (step: typeof workflowSteps[number], isLast: boolean) => (
    <div key={step.number} className="workflow-container">
      {renderBox(step)}
      {!isLast && <div className="workflow-arrow">→</div>}
    </div>
  );

  const renderBrace = (extendClass: string, color: string) => (
    <svg className={`group-brace ${extendClass}`} viewBox="0 0 200 40" preserveAspectRatio="none">
      <path
        d="M0,0 Q0,20 20,20 Q80,20 90,20 Q95,20 100,35 Q105,20 110,20 Q120,20 180,20 Q200,20 200,0"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );

  return (
    <div className="home-container">
      <div className="home-content">
        <div className="welcome-text">
          Welcome <span className="welcome-name">{firstName}</span>. Your ideas matter. Let's innovate together!
        </div>

        <div className="overview-section">
          <h2 className="section-title">How Our Approval Process Works</h2>
          <p className="section-description">
            Every AI solution idea goes through a structured review process to ensure quality, feasibility, and alignment with our organizational goals. Your contribution is valuable and helps us build better solutions.
          </p>
        </div>

        <div className="workflow-section">
          <div className="workflow-timeline">
            <div className="workflow-group group-a">
              <div className="workflow-group-row">
                {firstGroupSteps.map((step, index) => renderStep(step, index === firstGroupSteps.length - 1))}
              </div>
              {renderBrace('extend-right', '#CC0000')}
              <div className="group-label extend-right">Prescreener (This tool)</div>
            </div>
            <div className="connector-wrap">
              <div className="workflow-arrow">→</div>
            </div>
            <div className="workflow-container split-box">
              {renderBox(splitStep, 'linear-gradient(to right, #FFFDE7, #e8e8e8)')}
            </div>
            <div className="connector-wrap">
              <div className="workflow-arrow">→</div>
            </div>
            <div className="workflow-group group-b">
              <div className="workflow-group-row">
                {secondGroupSteps.map((step, index) => renderStep(step, index === secondGroupSteps.length - 1))}
              </div>
              {renderBrace('extend-left', '#0057B8')}
              <div className="group-label extend-left">AI Repository</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;

